import React from 'react';

const Calendar: React.FC = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <h2 className="text-lg font-semibold">Calendar</h2>
      <div className="flex justify-between items-center my-2">
        <button className="text-purple-600">&lt;</button>
        <span className="text-sm text-gray-700">agosto de 2024</span>
        <button className="text-purple-600">&gt;</button>
      </div>
      <div className="grid grid-cols-7 gap-2 text-center">
        <span>LUN</span>
        <span>MAR</span>
        <span>MIÉ</span>
        <span>JUE</span>
        <span>VIE</span>
        <span>SÁB</span>
        <span>DOM</span>
        {[...Array(31)].map((_, i) => (
          <div key={i} className={`p-2 ${i === 1 ? 'bg-purple-200' : ''} rounded-full`}>{i + 1}</div>
        ))}
      </div>
    </div>
  );
};

export default Calendar;
